import middleware from 'error-handler/functions/middleware';
import axios, { AxiosResponse } from 'axios';
import numbers from 'utils/numbers';

import { CountryPhone, IPhoneNumber } from 'ui/Phone/types';
import { defaultNumber } from 'ui/Phone/constants';

const getCountryQuery = async (): Promise<CountryPhone> => {
  let number: CountryPhone['number'] = defaultNumber;
  let mask: CountryPhone['mask'] = defaultNumber.mask;

  await middleware(
    () =>
      axios('https://www.searates.com/ajax/ip-info?type=get-country')
        .then((res: AxiosResponse<string>) => {
          const [numberInfo]: IPhoneNumber[] = numbers.filter((item: IPhoneNumber) => item.countryCode === res.data);
          if (!numberInfo) throw `Country not defined: ${res.data}`;
          number = numberInfo;
          mask = numberInfo.mask;
        })
        .catch(() => {
          console.warn('Country not defined');
        }),
    { Function: 'ip-info?type=get-country', errorInfo: 'Get country name Query SeaRates' }
  );

  return { number, mask };
};

export default getCountryQuery;
